import React, { useState } from 'react';
import {
    Paper,
  Typography,
  Box,
  TextField,
  Button,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';

const ChangePassword = () => {
  const navigate = useNavigate();
  const { updateUser, mustChangePassword, home } = useAuth();
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (passwords.newPassword !== passwords.confirmPassword) {
      setError('Les nouveaux mots de passe ne correspondent pas');
      return;
    }

    if (passwords.newPassword.length < 8) {
      setError('Le nouveau mot de passe doit contenir au moins 8 caractères');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('/api/auth/change-password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          currentPassword: passwords.currentPassword,
          newPassword: passwords.newPassword
        })
      });

      if (response.ok) {
        setSuccess('Mot de passe modifié avec succès');
        updateUser({ must_change_password: false });
        setTimeout(() => {
          navigate(home);
        }, 2000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erreur lors du changement de mot de passe');
      }
    } catch (error) {
      console.error('Erreur:', error);
      setError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Mot de passe" plain>
      <Box sx={{ maxWidth: 480 }}>
        <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Choisissez un mot de passe d'au moins 8 caractères.
          </Typography>
          
          {mustChangePassword && !success && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Votre mot de passe est provisoire : choisissez-en un nouveau pour accéder à l'application.
            </Alert>
          )}

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Mot de passe actuel"
              type="password"
              value={passwords.currentPassword}
              onChange={(e) => setPasswords({...passwords, currentPassword: e.target.value})}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Nouveau mot de passe"
              type="password"
              value={passwords.newPassword}
              onChange={(e) => setPasswords({...passwords, newPassword: e.target.value})}
              margin="normal"
              required
              helperText="Au moins 6 caractères"
            />
            <TextField
              fullWidth
              label="Confirmer le nouveau mot de passe"
              type="password"
              value={passwords.confirmPassword}
              onChange={(e) => setPasswords({...passwords, confirmPassword: e.target.value})}
              margin="normal"
              required
            />
            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                fullWidth
              >
                {loading ? 'Enregistrement…' : 'Enregistrer le mot de passe'}
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate(-1)}
                fullWidth
              >
                Annuler
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default ChangePassword;